import { useClientTokenManager } from '@cko/dashboard-shared';
import { useEffect } from 'react';
import { HeapAPI } from './HeapAPI';

export const useIdentifyUser = (isReady: boolean, api: HeapAPI) => {
  const { tokenProperties } = useClientTokenManager();
  const { sub: email } = tokenProperties;

  useEffect(() => {
    if (isReady && Boolean(email)) {
      api.identifyUser(email);
    }
  }, [isReady, email, api]);
};
